import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { WarningAmber } from '@shared-app/ui/icons';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as S from './styles';
export function Footer({ filteredCount }) {
    const { t } = useTranslation();
    return (_jsx(_Fragment, { children: filteredCount > 50 ? (_jsxs(S.SolutionAmount, { children: [filteredCount, " ", t('Solutions found')] })) : (_jsxs(S.SolutionErrorAmount, { children: [_jsx(WarningAmber, {}), ' ', _jsxs(Typography, { fontSize: 18, fontWeight: 700, children: [filteredCount, " ", t('Solutions found')] })] })) }));
}
